import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 10px 22px;
  font-size: 18px;
  width: 100%;
  gap: 10px;
  font-weight: bold;
  & input {
    padding: 10px 12px;
    border-radius: 12px;
    background: #e6e8e9;
    border: 1px solid #e6e8e9;
    outline: none;
    width: 100%;
  }
`;

const Cell = styled.div`
  display: flex;
  flex-direction: row;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 2px;
  align-items: center;
  font-weight: normal;
  width: 100%;
  justify-content: space-between;
  border: 1px solid #e6e8e9;
  border-right: 4px solid ${(props) => (props.isExpense ? 'red' : 'green')};
  position: relative;
  transition: transform 0.3s ease;
  overflow: hidden;

  &:hover {
    transform: translateX(-30px);
  }
`;

const DeleteButton = styled.button`
  position: absolute;
  right: 5px;
  background: crimson;
  color: white;
  border: none;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s ease;
  ${Cell}:hover & {
    opacity: 1;
  }
`;

const TransactionCell = ({ payload, onDelete }) => {
  const handleDelete = () => {
    const confirmDelete = window.confirm('Are you sure you want to delete this transaction?');
    if (confirmDelete && typeof onDelete === 'function') {
      onDelete(payload.id);
    }
  };

  return (
    <Cell isExpense={payload?.type === 'EXPENSE'}>
      <div>
        <span style={{ fontWeight: 'bold' }}>{payload.desc}</span>
        <div style={{ fontSize: '12px', color: '#888' }}>{payload.date}</div>
      </div>
      <span>₦{payload.amount}</span>
      <DeleteButton onClick={handleDelete}>Delete</DeleteButton>
    </Cell>
  );
};

const TransactionComponent = ({ transactions, deleteTransaction }) => {
  const [searchText, setSearchText] = useState('');
  const [filteredTransaction, setFilteredTxn] = useState(transactions);

  const filterData = (text = '') => {
    if (!text.trim()) {
      setFilteredTxn(transactions);
      return;
    }
    const txn = transactions.filter((payload) =>
      payload.desc.toLowerCase().includes(text.toLowerCase().trim())
    );
    setFilteredTxn(txn);
  };

  useEffect(() => {
    filterData(searchText);
  }, [searchText, transactions]);

  return (
    <Container>
      Transactions
      <input
        placeholder="Search"
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />
      {filteredTransaction?.length ? (
        filteredTransaction.map((payload) => (
          <TransactionCell
            key={payload.id}
            payload={payload}
            onDelete={deleteTransaction} // ✅ fixed prop name
          />
        ))
      ) : (
        <p>No transactions found</p>
      )}
    </Container>
  );
};

export default TransactionComponent;
